import { useMutation } from '@apollo/client';
import { gql } from 'graphql-tag';
import get from 'lodash.get';
import { BillStatus } from '~/types';
import { mapToBillingTransactionFilter } from './util';

export const UPDATE_BILL_BATCH_STATUS = gql`
  mutation updateBillStatusBatch($input: UpdateBillStatusBatchParameter!) {
    updateBillStatusBatch(updateBillStatusBatchParameter: $input) {
      batchUri
    }
  }
`;

export const useUpdateBillStatusBatch = ({
  excludedBillIds,
  isAllSelected,
  filter,
  setRecalculationBatchState,
  billIdsForIssue
}) => {
  const [updateBillStatusBatch, { loading }] = useMutation(
    UPDATE_BILL_BATCH_STATUS
  );

  return {
    updateBillStatusBatch: async () => {
      const { data } =
        (await updateBillStatusBatch({
          variables: {
            input: {
              billStatus: BillStatus.Billed,
              syncBillsInput: {
                includeBillIds: billIdsForIssue,
                excludeBillIds: excludedBillIds,
                allSelected: isAllSelected,
                filter: mapToBillingTransactionFilter({
                  filter
                })
              }
            }
          }
        })) || {};

      const batchId = get(data, 'updateBillStatusBatch.batchUri', null);

      setRecalculationBatchState({
        batchId,
        batchInProgress: true
      });
    },
    loading
  };
};
export default useUpdateBillStatusBatch;
